@file:kotlin.js.JsExport
/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */


package com.narbase.letsgo.web.routing.domain.passenger.login

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.passengers.PassengerDto


object PassengerLoginEndpoint : EndPoint<PassengerLoginEndpoint.Request, PassengerLoginEndpoint.Response>() {
    class Request (
        val phone: String,
        val code: String,
        val fcmToken: String?,
        val isAndroid: Boolean
    )

    class Response(
        val token: String?,
        val passenger: PassengerDto?
    )
}

